import * as handler from './handler';
import { PATH_USER_DETAILS } from './path';

const getUserDetails = (userId) =>
  handler.get(PATH_USER_DETAILS + userId).then((res) => {
    return res;
  });

const updatePersonalDetails = (userId, payload) =>
  handler.put(PATH_USER_DETAILS + userId, payload).then((res) => {
    return res;
  });

const updateFinancialProfile = (userId, payload) =>
  handler.put(`${PATH_USER_DETAILS + userId}/financial-profile`, payload).then((res) => {
    return res;
  });

const updateEmploymentProfile = (userId, payload) =>
  handler.put(`${PATH_USER_DETAILS + userId}/employment`, payload).then((res) => {
    return res;
  });

const updateAffiliations = (userId, payload) =>
  handler.put(`${PATH_USER_DETAILS + userId}/affiliations`, payload).then((res) => {
    return res;
  });

const getProfileDetails = (userId) =>
  handler.get(`${PATH_USER_DETAILS}protected-routes/${userId}`).then((res) => {
    return res;
  });

const updateProfileDetails = (userId, payload) =>
  handler.put(`${PATH_USER_DETAILS}protected-routes/${userId}`, payload).then((res) => {
    return res;
  });

const getConnectedPortfolios = (userId) =>
  handler.get(`${PATH_USER_DETAILS}protected-routes/${userId}/portfolios`).then((res) => {
    return res;
  });

const getOrderDetails = (userId) =>
  handler.get(`${PATH_USER_DETAILS}protected-routes/${userId}/recent-orders`).then((res) => {
    return res;
  });

export default {
  getUserDetails,
  updatePersonalDetails,
  updateFinancialProfile,
  updateEmploymentProfile,
  updateAffiliations,
  getProfileDetails,
  updateProfileDetails,
  getConnectedPortfolios,
  getOrderDetails,
};
